import React, { useState, useEffect } from 'react'
import './JobOffer.css'
import { Typography, Container, Divider, Button, Chip, Stack } from '@mui/material'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import ReCAPTCHA from 'react-google-recaptcha'
import { setApiKey } from '../../customHooks/setApiKey'

export default function JobOfferWeb() {
  const [state, setState] = useState(false)
  const [reCaptchaApiKey, setReCaptchaApiKey] = useState('')

  const onChange = () => {
    setState(true)
  }

  useEffect(() => {
    setApiKey(setReCaptchaApiKey)
  }, [])

  return (
    <>
      <div className='job-header'>
        <div className='job-header-content'>
          <Chip label='Job Offer' color='primary' variant='outlined' style={{ margin: '.5rem' }} />
          <Typography variant='h2' align='center' color='secondary'>
            Full Stack Developer
          </Typography>
        </div>
      </div>
      <Container className='job-container'>
        <Typography variant='h4' gutterBottom>
          Job Description
        </Typography>
        <Typography gutterBottom>
          We are Stuller, Inc., a just-in-time, prime manufacturer and distributor of jewelry and jewelry-related
          products. We are currently hiring a Full Stack developer to join the Web Team for our Barcelona's office. As a
          web developer the candidate will combine coding skills with an eye for design and will be helping to create,
          maintain, and support various web applications to better server our customers and employees.
        </Typography>
        <Divider />
        <Typography variant='h4' gutterBottom>
          Technical knowledge required
        </Typography>
        <ul>
          <li>React Hooks.</li>
          <li>Redux (Thunk, Saga, Observables...).</li>
          <li>Amazon Web Services (AWS).</li>
          <li>Typescript.</li>
          <li>Good level of written and spoken English.</li>
          <li>1 or + year(s) experience in web development.</li>
        </ul>
        <Divider />
        <Typography variant='h4' gutterBottom>
          Other skills
        </Typography>
        <ul>
          <li>GIT.</li>
          <li>Mobile first, responsive projects.</li>
          <li>Eslint, Prettier.</li>
          <li>Experience in testing frameworks.</li>
        </ul>
        <Divider />
        <Typography variant='h4' gutterBottom>
          What do we offer?
        </Typography>
        <ul>
          <li>Indefinite contract.</li>
          <li>Hour flexibility.</li>
          <li>100% remote (Residence outside Barcelona) or hybrid (2 days office).</li>
          <li>Annual performance evaluation and training.</li>
          <li>Intensive schedule on Fridays: from 8 am to 2 pm.</li>
          <li>Competitive salary and adapted to your value, range (27K to 30K).</li>
        </ul>
        <Divider />
        <Stack spacing={2} justifyContent='center' alignItems='center'>
          {reCaptchaApiKey && <ReCAPTCHA sitekey={reCaptchaApiKey} onChange={onChange} />}
          <Button
            size='large'
            color='primary'
            variant='contained'
            target='_blank'
            rel='noopener noreferrer'
            href={
              'mailto:mariana@tdmsolutions.com?subject=Web%20Developer%20-%20Applicant&cc=francisco_rodriguez@stuller.com&body=Please%20write%20us%20your%20motivation%20to%20join%20our%20team%20and%20attach%20your%20resume.'
            }
            startIcon={<MailOutlineIcon />}
            disabled={state === false}
            className='job-apply-button'
          >
            Apply
          </Button>
        </Stack>
      </Container>
    </>
  )
}
